<app-bx-sticky-action-bar
    [multiSelectActionCount]="1"
    [helpText]="helpText()"
    [showHelpText]="!!helpText()"
    (cancelClicked)="onCancelClicked()">
    <ng-container sticky-bar-desktop-actions>
        <button type="button" id="btnRemoveShape" (click)="removeShape()" class="btn-bx-secondary-stroked ml-1">
            <span>Remove Shape</span>
        </button>
        @if (drawing()?.shape === 'Polygon') {
            <button type="button" id="btnDeletePoint" [disabled]="!anchor()" (click)="deletePoint()" class="btn-bx-secondary-stroked ml-1">
                <span>Remove Selected Point</span>
            </button>
            <button
                type="button"
                id="addPointToDrawingShape"
                (click)="toggleAddPointMode()"
                [tooltip]="'Click to turn on/off ability to add points to the shape'"
                [class.btn-add-point-toggled]="addPointMode()"
                class="btn-bx-secondary-stroked ml-1">
                <span>Add Points</span>
            </button>
        }
    </ng-container>
</app-bx-sticky-action-bar>
